import { useUser } from "@/zustand-hooks/user-hook";

/**
 * Хук для проверки доступности банковских реквизитов
 * Используется для условного отображения пункта меню Bank в сайдбаре
 * Теперь использует настройки клиента из store, полученные через /refresh/customer
 */
export const useBankRequisitesAvailable = () => {
    const { clientSettings } = useUser();

    return {
        isAvailable: clientSettings?.display?.bankRequisitesAvailable ?? false,
        isLoading: false,
        error: null
    };
};

export default useBankRequisitesAvailable;

